import {
  makeStyles,
  mergeClasses,
  SelectTabData,
  SelectTabEvent,
  TabValue,
} from "@fluentui/react-components";
import React, { useEffect, useState } from "react";
import AADRoleEnum from "../../enum/AADRoleEnum";
import { SelectedTabEnum } from "../../enum/app-settings/AppSettingsEnum";
import PageEnum from "../../enum/PageEnum";
import { screenNameActions } from "../../store/screen/ScreenNameSlice";
import { useAppDispatch } from "../../store/StoreHooks";
import { getAppSettingsTabs } from "../../utils/app-settings/AppSettingsHelper";
import { AuthZ } from "../common/auth/AuthZ";
import AppSettingsTabs from "./AppSettingsTabs";
import DateTimeSettings from "./date-time-settings/DateTimeSettings";
import HopSettings from "./hop-settings/HopSettings";
import FlightKPISettings from "./kpi-settings/FlightKPISettings";
import { PaxSettings } from "./passenger-flow/PaxSettings";

export const AppSettings: React.FunctionComponent<{ airportCode: string }> = ({
  airportCode,
}) => {
  const roles = [AADRoleEnum.Admin];
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const [selectedTab, setSelectedTab] = useState<TabValue>(
    SelectedTabEnum.DATE_TIME
  );

  const onTabSelect = (_event: SelectTabEvent, data: SelectTabData) => {
    setSelectedTab(data.value);
  };

  const tabs = getAppSettingsTabs(airportCode);

  useEffect(() => {
    dispatch(
      screenNameActions.setScreenName(
        PageEnum.BreadcrumbEnum.ApplicationSettings
      )
    );
  }, [dispatch]);

  return (
    <AuthZ roles={roles} airportCode={airportCode}>
      <section data-testid="app-settings" className="amd-section-shadow">
        <AppSettingsTabs
          appSettingsTabs={tabs}
          selectedTab={selectedTab}
          onTabSelect={onTabSelect}
        />
        <div
          className={mergeClasses(classes.appSection, "pt-sm-6")}
          data-testid="app-settings-content"
        >
          {selectedTab === SelectedTabEnum.HEALTH_OF_OPERATIONS && (
            <HopSettings airportCode={airportCode} />
          )}
          {selectedTab === SelectedTabEnum.PASSENGER_FLOW && (
            <PaxSettings airportCode={airportCode} />
          )}
          {selectedTab === SelectedTabEnum.DATE_TIME && (
            <DateTimeSettings airportCode={airportCode} />
          )}
          {selectedTab === SelectedTabEnum.KPI_CONFIGURATION && (
            <FlightKPISettings airportCode={airportCode} />
          )}
        </div>
      </section>
    </AuthZ>
  );
};

const useStyles = makeStyles({
  appSection: {
    paddingLeft: "12px",
    minHeight: "422px",
  },
});
